import ProductoCard from "../tarjeta/ProductosCard.js";
import "./ProductosGrid.css";

export default function ProductoGrid({
  productos = [],
  productoActivo = null,
  onSelect,
  onAgregarAlCarrito,
}) {
  if (productos.length === 0) {
    return <p className="mensaje-vacio">No hay productos para mostrar</p>;
  }

  return (
    <div className="grupo-productos-grid">
      {productos.map((p) => (
        <ProductoCard
          key={p.Codigo}
          id={p.Codigo}
          nombre={p.nombre}
          precio={p.precio_unitario}
          seleccionado={productoActivo === p.id}
          onSelect={onSelect}
          onAgregarAlCarrito={onAgregarAlCarrito}
        />
      ))}
    </div>
  );
}
